<script>
import AdminLayout from '@layouts/admin-main'
import AdjustList from '@components/admin/brokerage-adjust-list'

export default {
  page: {
    title: 'Admin::BrokerageAdjustList',
    meta: [{ name: 'description', content: 'Admin::BrokerageAdjustList' }],
  },
  components: { AdminLayout, AdjustList },
}
</script>

<template>
  <AdminLayout>
    <AdjustList></AdjustList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
